export const normalizeSearchQuery = (value: string) =>
  value
    .trim()
    .replace(/\s+/g, " ")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export const onlyDigits = (value: string) => value.replace(/\D/g, "");

export const isPortugueseNif = (value: string) => {
  const nif = onlyDigits(value);

  if (!/^\d{9}$/.test(nif)) {
    return false;
  }

  const checkSum = nif
    .slice(0, 8)
    .split("")
    .reduce((total, digit, index) => total + Number(digit) * (9 - index), 0);

  const remainder = checkSum % 11;
  const checkDigit = remainder < 2 ? 0 : 11 - remainder;

  return checkDigit === Number(nif[8]);
};

export const normalizePortugueseNifSearch = (value: string) => {
  const trimmed = value.trim().toUpperCase();
  const withoutCountryPrefix = trimmed.startsWith("PT") ? trimmed.slice(2).trim() : trimmed;

  if (!/^\d(?:[\s.-]?\d){8}$/.test(withoutCountryPrefix)) {
    return null;
  }

  const nif = onlyDigits(withoutCountryPrefix);
  return isPortugueseNif(nif) ? nif : null;
};

export const formatNif = (value: string) => {
  const nif = onlyDigits(value);
  return nif.length === 9 ? `${nif.slice(0, 3)} ${nif.slice(3, 6)} ${nif.slice(6)}` : value;
};

export const isLikelyNifSearch = (value: string) => normalizePortugueseNifSearch(value) !== null;

export const normalizeEmail = (value: string) => value.trim().toLowerCase();

export const isValidEmail = (value: string) => {
  const email = normalizeEmail(value);

  if (email.length === 0 || email.length > 254 || email.includes("..")) {
    return false;
  }

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
